import isGAD7Form from "./isGAD7Form";
import isPHQ9Form from "./isPHQ9Form";

/**
 * get data by hard coded column name/value, xxxxx(0)
 * can be used to calculate gad-7 and phq-9
 */
export default function getFormScore(
  data: Record<string, Record<string, string>> | undefined,
  formTitle?: string,
) {
  if (!data || !formTitle) {
    return;
  }

  if (!isGAD7Form(formTitle) && !isPHQ9Form(formTitle)) {
    return;
  }

  const scoreData = Object.values(data)[0];

  if (!scoreData) {
    return;
  }

  return Object.values(scoreData).reduce((prev, curr) => {
    const scoreString = curr.match(/\((.*)\)$/)?.[1];

    if (!scoreString) {
      return prev;
    }

    return prev + +scoreString;
  }, 0);
}
